export default "__VITE_ASSET__DzInVVJC__"